export const Localvalue = {
    //******************************************* Video
    idVideo: "idvideo",
    linkVideo: "linkvideo",
    titleVideo: "titlevideo",
    contentVideo: "contentvideo",
    descriptionVideo: "descriptionvideo",
    //******************************************* Blog
    idBlog: "idblog",
    blogBlog: "blogvideo",
    titleBlog: "blogvideo",
    contentBlog: "contentvideo",
    descriptionBlog: "descriptionblog",
    //******************************************* School
    idSchool: "idSchool",
    titleSchool: "titleSchool",
    urlSchoolVideo: "videoSchool",
    urlSchoolAudio: "audioSchool",
    descriptionSchool: "descriptionSchool",
    //******************************************* Temoignage
    idTemoignage :"idTemoignage",
    titleTemoignage:"titleTemoignage",
    contentTemoignage:"contentTemoignage",
    descriptionTemoignage:"descriptionTemoignage",
    coverPictureTemoignage:"coverPictureTemoignage",
    videoTemoignage:"videoTemoignage",
    audioTemoignage:"audioTemoignage",

    namelogin:"namelogin",
    access:"accestoken",
    idlogin:"idlogin",


    // membre
    nameMemberLogin:"nameMemberLogin",
    accessMemberLogin:"accessMemberLogin",
    idMemberLogin:"IdMemberLogin:",
    coverPictureMemberLogin:"CoverPictureMemberLogin",
    emailMemnberLogin:"emailMemnberLogin",


    


    temoignageData :"temoignageData",
    enseignementData :"enseignementData",
    
    temoignagesData :"temoignagesData",
    enseignementsData :"enseignementsData",
    aboutusData :"aboutusData",
    activitePageData:"activitePageData",
    commentsData:"commentsData",
    usersData:"usersData",
    emailsData:"emailsData",
    membersData:"membersData",

}




export const valueLocal = {
    api_key_cine_pay : process.env.REACT_APP_API_KEY_CN,
    site_web_id_cinetpay: process.env.REACT_APP_SITE_WEB_CN
}